import Image from "next/image";

const OpportunityCard = ({ opportunity }) => (
  <div className="py-6 px-3 text-center rounded-lg shadow-lg">
    <div className="mx-auto w-16 h-16 text-purple bg-purple-800 rounded-full flex-center">
      <Image
        src={`${process.env.NEXT_PUBLIC_STORAGE_URL}/content/${opportunity.picture}`}
        alt={`${opportunity.title} icon`}
        width={24}
        height={24}
      />
    </div>
    <h3 className="mt-6 text-xl font-semibold">{opportunity.title}</h3>
    <p className="mt-3 text-grey-700">{opportunity.text}</p>
  </div>
);

export default OpportunityCard;
